import { Editor, Element, Node, Path, Text, Transforms } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

const types = serializer.types;
const layoutUtilities = serializer.utilities.node.layout;

function isInlineChild(editor, child) {

  if (Text.isText(child) === true) {
    return true;
  }

  return Element.isElement(child) === true && Editor.isInline(editor, child) === true;

}

function findOutermostLayoutPath(editor, path) {

  let outermostPath = path;

  for (const [ancestor, ancestorPath] of Node.ancestors(editor, path, { reverse: true })) {
    if (ancestor.type === types.LAYOUT) {
      outermostPath = ancestorPath;
    }
  }

  return outermostPath;

}

function wrapInlineRun(editor, path, startIndex) {

  const layout = Node.get(editor, path);
  const run = [];
  let index = startIndex;

  while (index < layout.children.length && isInlineChild(editor, layout.children[index]) === true) {
    run.push(JSON.parse(JSON.stringify(layout.children[index])));
    index++;
  }

  const paragraph = serializer.utilities.node.paragraph.buildNode();
  paragraph.children = run;

  Editor.withoutNormalizing(editor, function replaceRun() {
    for (let removeIndex = index - 1; removeIndex >= startIndex; removeIndex--) {
      Transforms.removeNodes(editor, { at: path.concat(removeIndex) });
    }
    Transforms.insertNodes(editor, paragraph, { at: path.concat(startIndex) });
  });

}

function fixChild(editor, path, child, index) {

  const childPath = path.concat(index);

  if (isInlineChild(editor, child) === true) {
    wrapInlineRun(editor, path, index);
    return true;
  }

  if (child.type === types.COLUMNS) {
    Transforms.moveNodes(editor, { at: childPath, to: Path.next(findOutermostLayoutPath(editor, path)) });
    return true;
  }

  if (layoutUtilities.canContain(child.type) === true) {
    return false;
  }

  if (Editor.isVoid(editor, child) === true) {
    Transforms.removeNodes(editor, { at: childPath });
    return true;
  }

  Transforms.unwrapNodes(editor, { at: childPath });
  return true;

}

export function normalizeLayoutChildren(editor, node, path) {

  if (node.children.length === 0) {
    Transforms.insertNodes(editor, serializer.utilities.node.paragraph.buildNode(), { at: path.concat(0) });
    return true;
  }

  for (let index = 0; index < node.children.length; index++) {
    if (fixChild(editor, path, node.children[index], index) === true) {
      return true;
    }
  }

  return false;

}
